import router from "@/router";
import store from "@/store";
import {routerNext} from "@/hook/useRouteNext";

const whiteList = ['/404', '/login']

router.beforeEach((to, from, next) => {
    // 在免登录白名单，直接进入
    if (whiteList.includes(to.path)) {
        next()
        return
    }
    if (store.state.menu.length === 0) {
        store.dispatch('getUserInfo').then(r => {
            store.dispatch('getUserPermission').then(a => {
                routerNext(to.path).then(a => {
                    next()
                })
            })
        })
    } else {
        routerNext(to.path).then(a => {
            next()
        })
    }

})